// 统一请求路径前缀在libs/axios.js中修改
import {postRequest} from '@/libs/axios';

// 删除
export const remove = (ids) => {
    return postRequest("/base/coursecomment/remove", {
        ids: ids
    })
}

// 列表
export const list = (params) => {
    return postRequest('/base/coursecomment/list', params)
}

